import React from 'react';
import { Switch } from './ui/switch';
import { Input } from './ui/input';
import { Label } from './ui/label';

const DAYS = [
  { k: '1', l: 'Segunda' },
  { k: '2', l: 'Terça' },
  { k: '3', l: 'Quarta' },
  { k: '4', l: 'Quinta' },
  { k: '5', l: 'Sexta' },
  { k: '6', l: 'Sábado' },
  { k: '0', l: 'Domingo' },
];

export default function BusinessHoursEditor({ value, onChange, title = 'Horário de atendimento', hint = 'Mostra o status aberto/fechado em tempo real no biosite.' }) {
  const v = value || { enabled: false, timezone: 'America/Sao_Paulo', days: {} };
  const upd = (patch) => onChange({ ...v, ...patch });
  const updDay = (k, patch) => upd({ days: { ...v.days, [k]: { ...(v.days?.[k] || {}), ...patch } } });

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <div>
          <Label className="text-sm font-semibold">{title}</Label>
          <p className="text-xs text-neutral-500">{hint}</p>
        </div>
        <Switch checked={!!v.enabled} onCheckedChange={(x) => upd({ enabled: x })} />
      </div>
      <div className="space-y-2">
        {DAYS.map((d) => {
          const cur = v.days?.[d.k] || { enabled: false, open: '09:00', close: '18:00' };
          return (
            <div key={d.k} className="flex items-center gap-3 bg-neutral-50 border border-neutral-200 rounded-xl p-3">
              <Switch checked={!!cur.enabled} onCheckedChange={(x) => updDay(d.k, { enabled: x })} />
              <div className="w-20 text-sm font-medium">{d.l}</div>
              <div className="flex items-center gap-2 flex-1">
                <Input type="time" value={cur.open || '09:00'} onChange={(e) => updDay(d.k, { open: e.target.value })} disabled={!cur.enabled} className="max-w-[130px]" />
                <span className="text-neutral-400 text-sm">até</span>
                <Input type="time" value={cur.close || '18:00'} onChange={(e) => updDay(d.k, { close: e.target.value })} disabled={!cur.enabled} className="max-w-[130px]" />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
